<prism-status-indicator
	*transloco="let t; read: 'scDeviceStateBar'"
	id="sh-device-state-bar"
	shape="rectangle"
	[status]="prismState()"
	[matTooltip]="statusTooltip()"
></prism-status-indicator>
